import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLayoutEffect, useRef, Fragment, useState } from 'react';
import { exposeTestId } from '../../config';
import { VisualizationState } from '../../store/birdElement/visualizationState';
import { MessageState } from '../../store/message/MessageState';
import { BirdAboutInfo } from '../BirdAboutInfo';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectMessageState, selectLayoutState, selectAccessibilityLabelState, } from '../../store/selectors';
import { ReportContextMenuState } from '../../store/reportContextMenu/ReportContextMenuState';
import GestureHelper from '@sas-dvr/ltjs-commons/gestures/GestureHelper';
import { createUniqueId } from '../utils/createUniqueId';
import { useMessageToast } from '../utils/messageToast';
//css
import cn from './BIRDVisualization.css.json';
import './BIRDVisualization.css';
export const BIRDVisualizationBase = function (props) {
    const [contentId] = useState(createUniqueId);
    const { messageActions, actions, hasPosition, isSingleObject } = props;
    const contentRef = useRef(null);
    const messageToast = useMessageToast({
        message: props.message,
        referenceElementRef: contentRef,
        onDismiss: () => messageActions.set(props.id, undefined),
    });
    useLayoutEffect(function () {
        // Sometimes the map has the wrong zoom state if it is first rendered at the smallest size.
        //  To fix this, wait for at least one layout before setting the contentId to delay the first
        //  render of the map. SingleObject does not rely on portable for layout.
        if (!hasPosition && !isSingleObject) {
            actions.update(props.id, { contentId: undefined });
            return;
        }
        actions.update(props.id, { contentId });
        return function () {
            actions.update(props.id, { contentId: undefined });
        };
    }, [actions, contentId, props.id, hasPosition, isSingleObject]);
    const style = {};
    if (props.minWidth) {
        style.minWidth = props.minWidth + 'px';
    }
    if (props.minHeight) {
        style.minHeight = props.minHeight + 'px';
    }
    return (_jsxs(Fragment, { children: [_jsx("div", { id: contentId, "data-testid": exposeTestId() ? props.id + '-content' : null, className: cn.visualization, tabIndex: 0, ref: contentRef, "aria-label": props.accessibilityLabel, style: Object.assign(Object.assign({}, style), { 
                    // set position:relative so that child elements (such as the zoom message overlay)
                    // can set their position correctly.
                    position: 'relative', display: 'flex', flexShrink: 1, width: '100%', height: '100%' }), onContextMenu: (e) => {
                    const position = GestureHelper.getMousePosition(e.nativeEvent, e.currentTarget, true);
                    props.menuActions.setGraphPosition(position);
                } }), messageToast, _jsx(BirdAboutInfo, { id: props.id })] }));
};
export const BIRDVisualization = connect((state, props) => {
    var _a;
    const { constraints, position } = selectLayoutState(state, props.id);
    const isSingleObject = !!((_a = selectLayoutState(state, `media-${props.id}`)) === null || _a === void 0 ? void 0 : _a.isSingleObject);
    return {
        message: selectMessageState(state, props.id),
        minWidth: constraints === null || constraints === void 0 ? void 0 : constraints.minWidth,
        minHeight: constraints === null || constraints === void 0 ? void 0 : constraints.minHeight,
        accessibilityLabel: selectAccessibilityLabelState(state, props.id),
        hasPosition: !!position,
        isSingleObject: isSingleObject,
    };
}, (dispatch) => ({
    actions: bindActionCreators(VisualizationState.actions, dispatch),
    messageActions: bindActionCreators(MessageState.actions, dispatch),
    menuActions: bindActionCreators(ReportContextMenuState.actions, dispatch),
}))(BIRDVisualizationBase);
